import React, { useEffect } from 'react';
import images from '../images';
import styles from '../css/PorQueElegirnos.module.scss'
import { DatoContacto } from './DatoContacto';
import { Titulo } from './Titulo';
import { Acordeon } from './Acordeon';
export const PorQueElegirnos = () => {

    const itemsAcordeon = [
        { titulo: 'Asesoramiento integral', descripcion: 'Contamos con un equipo de trabajo con profesionales capacitados, y especializados en brindar un servicio completo. Nos distingue un compromiso de excelencia en la calidad de nuestros productos y servicios.' },
        { titulo: 'Reparaciones', descripcion: 'Se reacondicionan a nuevo artículos como reguladores de presión, sopletes, soldadoras, torchas, tortugas de corte, nacionales e importados.' },
        { titulo: 'Instalaciones para producción industrial', descripcion: 'Trabajamos en la instalación.' }
    ];

    return (
        <div id='contacto' className={styles.porQueElegirnos + ' text-white'}>
            <div className='container-fluid'>
                <div className='row '>
                    <div className={styles.contendidoPorQue + ' col-7 my-5'}>
                        <Titulo texto={"POR QUÉ ELEGIRNOS"} classSubrayado={'w-100'} subrayar={true} />
                        <Acordeon items={itemsAcordeon}/>
                    </div>
                    <div className={'col-5 text-center ' + styles.imagenPorQue}>
                    </div>
                </div>
            </div>
        </div>
    )

}